<template>
  <div v-if="subject" class="row-box">
    <Subject :subject="subject" :statement="statement" />
  </div>
</template>

<script>
import Subject from '@/components/elements/statement/FullStatementView/elements/Subject';

export default {
  name: 'Step3',
  components: {
    Subject,
  },
  props: {
    statement: {
      type: Object,
      required: true,
    },
    subject: {
      type: Object,
      required: true,
    },
  },
};
</script>
